export enum AppEvent {
	ANIMATE_CLONED_FLOW_CARD = 0,
	EXPAND_ALL_CARDS = 1,
	COLLAPSE_ALL_CARDS = 2,
	COLLAPSE_EXPAND_CARD = 3,
	SCROLL_TO_CARD = 5,
	CARD_VIEW_CHANGED = 6,
	UPDATE_LEXICAL_EDITOR_VIEW_MODE = 7,
	IS_FLOW_ITEM_FORM_CHANGED = 8
}

export type EventPayloads = {
	[AppEvent.ANIMATE_CLONED_FLOW_CARD]: { cardId: string };
	[AppEvent.EXPAND_ALL_CARDS]: undefined;
	[AppEvent.COLLAPSE_ALL_CARDS]: undefined;
	[AppEvent.COLLAPSE_EXPAND_CARD]: { cardId: string; isCollapsed: boolean };
	[AppEvent.SCROLL_TO_CARD]: { cardId: string };
	[AppEvent.CARD_VIEW_CHANGED]: { isDescriptionView: boolean; cardId: string };
	[AppEvent.UPDATE_LEXICAL_EDITOR_VIEW_MODE]: { isFormattedView: boolean };
	[AppEvent.IS_FLOW_ITEM_FORM_CHANGED]: { isFormChanged: boolean };
};

export type Listener<K extends AppEvent> = EventPayloads[K] extends void
	? () => void
	: (payload: EventPayloads[K]) => void;

export type Args<K extends AppEvent> = EventPayloads[K] extends void
	? []
	: [EventPayloads[K]];
